import React from "react"
import { RaisedButton, IconButton, FontIcon } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { blueGrey500 } from "material-ui/styles/colors"
import * as payrollHelper from "../../helpers/payrollHelper"
import moment from "moment"
import { IDateRange, IDate } from "../../models"
import FinddDatePicker from "../common/FinddDatePicker"
interface IProps {
    referenceDate: Date
    selectedPayGroupId: string
    handleChangeDate(referenceDate: IDate): void

    // Export TimecardDifference need to hide the Previous, Current period Buttons
    hidePrevNextPeriodButtons?: boolean
}
interface IState {
    thisPayrollPeriod: IDateRange
    lastPayrollPeriod: IDateRange
}

export default class PayrollPeriodDateButtons extends React.Component<IProps, IState> {
    private FinddDatePicker
    constructor(props: IProps) {
        super(props)
        const thisLastPayrollPeriod = payrollHelper.getThisLastPayrollPeriod(props.selectedPayGroupId)
        this.state = {
            thisPayrollPeriod: thisLastPayrollPeriod.thisPayrollPeriod,
            lastPayrollPeriod: thisLastPayrollPeriod.lastPayrollPeriod
        }
        autobind(this)

    }

    componentWillReceiveProps(nextProps: IProps) {
        if (this.props.selectedPayGroupId !== nextProps.selectedPayGroupId) {
            const thisLastPayrollPeriod = payrollHelper.getThisLastPayrollPeriod(nextProps.selectedPayGroupId)
            this.setState({
                thisPayrollPeriod: thisLastPayrollPeriod.thisPayrollPeriod,
                lastPayrollPeriod: thisLastPayrollPeriod.lastPayrollPeriod
            })
        }
    }

    getStyleLabel(type) {
        return type === "this" ?
            moment(this.props.referenceDate).isBetween(this.state.thisPayrollPeriod.StartDate, this.state.thisPayrollPeriod.EndDate) ?
                Object.assign({}, styles.label, styles.activeLabel) :
                styles.label :
            moment(this.props.referenceDate).isBetween(this.state.lastPayrollPeriod.StartDate, this.state.lastPayrollPeriod.EndDate) ?
                Object.assign({}, styles.label, styles.activeLabel) :
                styles.label
    }

    getStyleBtn(type) {
        return type === "this" ?
            moment(this.props.referenceDate).isBetween(this.state.thisPayrollPeriod.StartDate, this.state.thisPayrollPeriod.EndDate) ?
                Object.assign({}, styles.btn, styles.activeBtn) :
                styles.btn :
            moment(this.props.referenceDate).isBetween(this.state.lastPayrollPeriod.StartDate, this.state.lastPayrollPeriod.EndDate) ?
                Object.assign({}, styles.btn, styles.activeBtn) :
                styles.btn
    }

    render() {
        return (
            <div>
                <ul style={styles.ul}>
                    {!this.props.hidePrevNextPeriodButtons && [
                        <RaisedButton
                            key="prev"
                            data-intercom-target={"Payroll-Btn-PreviousPayPeriod"}
                            label={strings.Last_Pay_Period.toUpperCase()}
                            style={styles.root}
                            onTouchTap={() => this.props.handleChangeDate(moment(this.state.lastPayrollPeriod.StartDate).add(1, "day").format())}
                            labelStyle={this.getStyleLabel("last")}
                            buttonStyle={this.getStyleBtn("last")}
                        />,
                        <RaisedButton
                            key="current"
                            data-intercom-target={"Payroll-Btn-CurrentPayPeriod"}
                            label={strings.This_Pay_Period.toUpperCase()}
                            style={styles.root}
                            onTouchTap={() => this.props.handleChangeDate(moment(this.state.thisPayrollPeriod.StartDate).add(1, "day").format())}
                            labelStyle={this.getStyleLabel("this")}
                            buttonStyle={this.getStyleBtn("this")}
                        />
                    ]}
                    <IconButton
                        data-intercom-target={"Payroll-Btn-PickPeriodDate"}
                        onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()}
                        tooltip={strings.Pick_a_date}
                    >
                        <FontIcon className="fa fa-calendar fa-lg" />
                    </IconButton>
                </ul>
                <div>
                    <FinddDatePicker
                        ref={item => this.FinddDatePicker = item}
                        id="dp-text-field"
                        textFieldStyle={{ display: "none" }}
                        value={this.props.referenceDate}
                        onChange={(_, referenceDate) => this.props.handleChangeDate(referenceDate)}
                        cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                        firstDayOfWeek={0}
                    />
                </div>
            </div>
        )
    }
}

const styles = {
    ul: {
        margin: "0",
        paddingLeft: "20px"
    },
    root: {
        marginRight: "5px"
    },
    btn: {
        background: "white"
    },
    label: {
        fontSize: "14px"
    },
    activeBtn: {
        background: "#A9A9A9"
    },
    activeLabel: {
        color: "white"
    }
}
